import React from 'react';
import { Navigate } from 'react-router-dom';
import useAuthStore from '../../../stores/authStore';

/**
 * ProtectedRoute Component
 * 인증이 필요한 라우트를 보호하는 컴포넌트
 */
const ProtectedRoute = ({ children }) => {
  const isAuthenticated = useAuthStore(state => state.isAuthenticated());

  if (!isAuthenticated) {
    return <Navigate to="/login" replace />;
  }

  return <>{children}</>;
};

export default ProtectedRoute;
